export default function(theme) {
  return {
    footer: {
      fontSize: 14,
      fontWeight: 300,
      lineHeight: "18px",
      letterSpacing: 0,
      color: theme.colors.black45,
      '@media (max-width: 600px)': {
        marginTop: 'auto'
      }
    }
  }
}
